<div class="row">
    <div class="col-6 mb-4">
        <a routerLink="../../../oferte/oferta/{{offerId}}" class="btn text-white blue-bg">Vezi Oferta</a>
    </div>
    <div class="col-6 text-right mb-4">
        <a routerLink="../../../oferte/lista-oferte" class="btn text-white blue-bg">Toate Ofertele</a>
    </div>
</div>

<div class="card card-custom gutter-b" *ngIf="isLoaded">
    <div class="card-header">
        <div class="card-title">
            <h3 class="card-label">Editeaza Oferta</h3>
        </div>
    </div>
    <div class="card-body">
        <form #editOfferForm='ngForm' (ngSubmit)="editOffer(editOfferForm)">
            <div class="row">
                <div class="col-md-6 col-12">
                    <div class="form-group">
                        <label>Nume</label>
                        <input
                                type="text"
                                class="form-control"
                                name="name"
                                [(ngModel)]="offerData.name"
                                placeholder="Nume"
                                required
                                #offerTitle='ngModel'
                        />
                        <div class="error-msg"
                             *ngIf="!offerTitle.valid && (offerTitle.touched || editOfferForm.submitted)">
                            Acest camp este obligatoriu!
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-12" *ngIf="clientDataLoaded">
                    <div class="form-group">
                        <label for="clientUserId" class="m-0">Client User</label>
                        <ng-select2 [data]="clientUserId"
                                    [options]="singleOption"
                                    id="clientUserId"
                                    [(ngModel)]="offerData.clientUserId"
                                    name="clientUserId"
                                    required
                                    #clientUser='ngModel'
                        >
                        </ng-select2>
                        <div class="error-msg"
                             *ngIf="!clientUser.valid && (clientUser.touched || editOfferForm.submitted)">
                            Acest camp este obligatoriu!
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-12">
                    <div class="form-group">
                        <label for="offerDate" class="m-0">Data Ofertarii</label>
                        <input class="form-control"
                               id="offerDate"
                               type="date"
                               [(ngModel)]="offerData.offerDate"
                               name="offerDate"
                        >
                    </div>
                </div>
                <div class="col-md-6 col-12">
                    <div class="form-group">
                        <label for="deadline" class="m-0">Termen Limita</label>
                        <input class="form-control"
                               id="deadline"
                               type="date"
                               [(ngModel)]="offerData.deadline"
                               name="deadline"
                        >
                    </div>
                </div>
                <div class="col-md-6 col-12">
                    <div class="form-group">
                        <label for="observation" class="m-0">Observatii</label>
                        <textarea class="form-control"
                                  id="observation"
                                  [(ngModel)]="offerData.observation"
                                  name="observation"
                        >
                        </textarea>
                    </div>
                </div>

                <div class="col-md-6 col-12">
                    <div class="form-group">
                        <label for="status" class="m-0">Status</label>
                        <select id="status" class="form-control" [(ngModel)]="offerData.status" name="status" required
                                #offerStatus='ngModel'>
                            <option selected value="draft">Ciorna</option>
                            <option value="sent">Trimis</option>
                            <option value="accepted">Acceptat</option>
                            <option value="declined">Respins</option>
                            <option value="archived">Arhivat</option>
                        </select>
                        <div class="error-msg"
                             *ngIf="!offerStatus.valid && (offerStatus.touched || editOfferForm.submitted)">
                            Acest camp este obligatoriu!
                        </div>
                    </div>
                </div>

                <div class="col-12">
                    <div class="row">
                        <!--Product List-->
                        <div class="col-md-6 col-12">
                            <h2 class="m-0">Lista Produse</h2>
                            <span class="d-block mb-4 text-danger">Este necesar cel putin un produs!</span>
                            <div class="row">
                                <div class="col-12">
                                    <ng-template ngFor let-productList [ngForOf]="repeaterData.productList"
                                                 let-index="index"
                                                 ngModelGroup="productList" [ngForTrackBy]="trackByFunction">
                                        <div class="mb-5">
                                            <div class="row" ngModelGroup="{{index}}">
                                                <div class="col-7">
                                                    <div class="form-group mb-0">
                                                        <label class="m-0" for="productName">Nume Produs</label>
                                                        <input type="text"
                                                               id="productName"
                                                               class="form-control"
                                                               [(ngModel)]="productList.name"
                                                               name="name"
                                                               required
                                                               #productName='ngModel'
                                                        >
                                                        <div class="error-msg"
                                                             *ngIf="!productName.valid && (productName.touched || editOfferForm.submitted)">
                                                            Acest camp este obligatoriu!
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-4">
                                                    <div class="form-group mb-0">
                                                        <label class="m-0" for="productPrice">Pret Produs</label>
                                                        <div class="input-group">
                                                            <input type="number"
                                                                   id="productPrice"
                                                                   class="form-control"
                                                                   [(ngModel)]="productList.price"
                                                                   name="price"
                                                                   min="0"
                                                                   required
                                                                   #productPrice='ngModel'
                                                            >
                                                            <div class="input-group-prepend">
                                                                <div class="input-group-text currency-box">€</div>
                                                            </div>
                                                            <div class="error-msg"
                                                                 *ngIf="!productPrice.valid && (productPrice.touched || editOfferForm.submitted)">
                                                                Acest camp este obligatoriu!
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-1 mt-6 p-0">
                                                    <button (click)="removeProduct( index )" type="button"
                                                            title="Remove Product" class="remove btn btn-danger"> X
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </ng-template>
                                    <p class="actions">
                                        <button class="form-control add-repeater mb-10" type="button"
                                                (click)="addProduct()"> Mai adauga un produs
                                        </button>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <!--Notes-->
                        <div class="col-md-6 col-12">
                            <h2>Notite</h2>
                            <div class="row">
                                <div class="col-12">
                                    <ng-template ngFor let-personalNotes [ngForOf]="repeaterData.personalNotes"
                                                 let-index="index" ngModelGroup="personalNotes"
                                                 [ngForTrackBy]="trackByFunction">
                                        <div class="mb-5">
                                            <div class="row" ngModelGroup="{{index}}}">
                                                <div class="col-11">
                                                    <div class="form-group mb-0">
                                                        <label class="m-0" for="personalNote">Notita</label>
                                                        <textarea name="note"
                                                                  class="form-control"
                                                                  id="personalNote"
                                                                  rows="5"
                                                                  [(ngModel)]="personalNotes.note"
                                                        >
                                                        </textarea>
                                                    </div>
                                                </div>
                                                <!--Author-->
                                                <div class="col-md-11 col-6 d-none">
                                                    <div class="form-group mb-0">
                                                        <input name="author" class="form-control"
                                                               [(ngModel)]="personalNotes.author">
                                                    </div>
                                                </div>
                                                <!--Date-->
                                                <div class="col-md-11 col-6 d-none">
                                                    <div class="form-group mb-0">
                                                        <input type="date" name="date" class="form-control"
                                                               [(ngModel)]="personalNotes.date">
                                                    </div>
                                                </div>
                                                <div class="col-1 mt-6 p-0">
                                                    <button (click)="removePersonalNotes( index )"
                                                            type="button"
                                                            title="Remove Note"
                                                            class="remove btn btn-danger">
                                                        X
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </ng-template>
                                    <p class="actions">
                                        <button class="form-control add-repeater mb-10" type="button"
                                                (click)="addPersonalNotes()">Mai adauga o notita
                                        </button>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-12">
                    <app-form-message [success]="formResponse" *ngIf="formSent"></app-form-message>

                    <button type="submit" class="btn btn-primary w-100">
                        Salveaza Oferta
                    </button>
                </div>
            </div>
        </form>
    </div>
</div>
